import { CourseType } from '../../../types'
import { getCourseCompletedPercentage } from '.'

export const getCourseCompletedStatus = (course?: CourseType) => {
  if (!course?.modules) {
    return {
      label: 'Not Started',
      percentage: 0
    }
  }

  const percentage = getCourseCompletedPercentage(course)

  if (percentage === 0) {
    return {
      label: 'Not Started',
      percentage: 0
    }
  }

  if (percentage < 100) {
    return {
      label: `${Math.floor(percentage)}% complete`,
      percentage
    }
  }

  return {
    label: 'Completed',
    percentage: 100
  }
}
